import { template } from "@ember/template-compiler";
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { Input } from "@ember/component";
import { fn, hash } from "@ember/helper";
import { on } from "@ember/modifier";
import { action } from "@ember/object";
import { service } from "@ember/service";
import DButton from "discourse/components/d-button";
import concatClass from "discourse/helpers/concat-class";
import withEventValue from "discourse/helpers/with-event-value";
import icon from "discourse-common/helpers/d-icon";
import i18n from "discourse-common/helpers/i18n";
import discourseLater from "discourse-common/lib/later";
import IconPicker from "select-kit/components/icon-picker";
export default class SectionFormLink extends Component {
    @service
    site;
    @tracked
    dragCssClass;
    dragCount = 0;
    isAboveElement(event1) {
        event1.preventDefault();
        const target1 = event1.currentTarget;
        const domRect1 = target1.getBoundingClientRect();
        return event1.offsetY < domRect1.height / 2;
    }
    @action
    dragHasStarted(event1) {
        event1.dataTransfer.effectAllowed = "move";
        this.args.setDraggedLinkCallback(this.args.link);
        this.dragCssClass = "dragging";
    }
    @action
    dragOver(event1) {
        event1.preventDefault();
        if (this.dragCssClass !== "dragging") {
            if (this.isAboveElement(event1)) {
                this.dragCssClass = "drag-above";
            } else {
                this.dragCssClass = "drag-below";
            }
        }
    }
    @action
    dragEnter() {
        this.dragCount++;
    }
    @action
    dragLeave() {
        this.dragCount--;
        if (this.dragCount === 0 && (this.dragCssClass === "drag-above" || this.dragCssClass === "drag-below")) {
            discourseLater(()=>{
                this.dragCssClass = null;
            }, 10);
        }
    }
    @action
    dropItem(event1) {
        event1.stopPropagation();
        this.dragCount = 0;
        this.args.reorderCallback(this.args.link, this.isAboveElement(event1));
        this.dragCssClass = null;
    }
    @action
    dragEnd() {
        this.dragCount = 0;
        this.dragCssClass = null;
    }
    static{
        template(`
    <div
      {{on "dragstart" this.dragHasStarted}}
      {{on "dragover" this.dragOver}}
      {{on "dragenter" this.dragEnter}}
      {{on "dragleave" this.dragLeave}}
      {{on "dragend" this.dragEnd}}
      {{on "drop" this.dropItem}}
      role="row"
      data-row-id={{@link.objectId}}
      draggable="true"
      class={{concatClass
        "sidebar-section-form-link"
        "row-wrapper"
        this.dragCssClass
      }}
    >
      {{#if this.site.desktopView}}
        <div class="draggable" data-link-name={{@link.name}}>
          {{icon "grip-lines"}}
        </div>
      {{/if}}

      <div class="input-group" role="cell">
        <IconPicker
          @name="icon"
          @value={{@link.icon}}
          @options={{hash
            maximum=1
            caretDownIcon="caret-down"
            caretUpIcon="caret-up"
            icons=@link.icon
          }}
          @onlyAvailable={{true}}
          @onChange={{fn (mut @link.icon)}}
          aria-label={{i18n "sidebar.sections.custom.links.icon.label"}}
          class={{@link.iconCssClass}}
        />

        {{#if @link.invalidIconMessage}}
          <div class="icon warning" role="alert" aria-live="assertive">
            {{@link.invalidIconMessage}}
          </div>
        {{/if}}
      </div>

      <div class="input-group" role="cell">
        <Input
          {{on "input" (withEventValue (fn (mut @link.name)))}}
          @type="text"
          @value={{@link.name}}
          name="link-name"
          aria-label={{i18n "sidebar.sections.custom.links.name.label"}}
          class={{@link.nameCssClass}}
        />

        {{#if @link.invalidNameMessage}}
          <div role="alert" aria-live="assertive" class="name warning">
            {{@link.invalidNameMessage}}
          </div>
        {{/if}}
      </div>

      <div class="input-group" role="cell">
        <Input
          {{on "input" (withEventValue (fn (mut @link.value)))}}
          @type="text"
          @value={{@link.value}}
          name="link-url"
          aria-label={{i18n "sidebar.sections.custom.links.value.label"}}
          class={{@link.valueCssClass}}
        />

        {{#if @link.invalidValueMessage}}
          <div role="alert" aria-live="assertive" class="value warning">
            {{@link.invalidValueMessage}}
          </div>
        {{/if}}
      </div>

      <DButton
        @icon="trash-alt"
        @action={{fn @deleteLink @link}}
        @title="sidebar.sections.custom.links.delete"
        role="cell"
        class="btn-flat delete-link"
      />
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
